import { render, staticRenderFns } from "./c_richtextarea.vue?vue&type=template&id=64349635"
import script from "./c_richtextarea.vue?vue&type=script&lang=js"
export * from "./c_richtextarea.vue?vue&type=script&lang=js"
import style0 from "./c_richtextarea.vue?vue&type=style&index=0&id=64349635&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports